import TermsAndConditionContainer from './TermsAndConditionContainer';
export default TermsAndConditionContainer;